import React, { useState } from 'react';
import styled from 'styled-components';

import { DeliveryInfoForm } from 'pages/Totem/TotemDashboard/DeliveryInfoForm';

import { PopupTitle } from 'styles/pages/settings.styles';

interface CreateTotemDeliveryInfoProps {
    deliveryInfo: any;
    onSubmit: (newDeliveryInfo: any) => void;
    isAddressNonEditable?: boolean;
}

export const CreateTotemDeliveryInfo: React.FC<CreateTotemDeliveryInfoProps> = ({
    deliveryInfo,
    onSubmit,
    isAddressNonEditable,
}) => {
    const [tempDeliveryInfo, setTempDeliveryInfo] = useState<any>(deliveryInfo);
    const sendFormContent = (newDeliveryInfo: any) => {
        onSubmit(newDeliveryInfo);
    };

    return (
        <Container>
            <PopupTitle>Informations du nouveau point de livraison</PopupTitle>
            <DeliveryInfoForm
                buttonFontSize={16}
                currentTotem={deliveryInfo}
                deliveryInfo={tempDeliveryInfo}
                setDeliveryInfo={setTempDeliveryInfo}
                sendFormContent={sendFormContent}
                isAddressNonEditable={isAddressNonEditable}
                loading={false}
                isCreatingAddress
            />
        </Container>
    );
};

const Container = styled.div`
    padding: 0 20px;
`;
